// extracted by mini-css-extract-plugin
export default {"btn":"successModal_btn__CKkZz","inner":"successModal_inner__KSSe2","img":"successModal_img__lmU4v","title":"successModal_title__iB6mo","cancel":"successModal_cancel__-czln"};